import { Chip, SxProps } from "@mui/material";

interface ProvisionalWasteStreamChipProps {
  isProvisional: boolean;
  sx?: SxProps;
}

export const ProvisionalWasteStreamChip = ({
  isProvisional,
  sx,
}: ProvisionalWasteStreamChipProps) => {
  if (!isProvisional) {
    return null;
  }
  return <Chip label="Provisional" size="small" variant="outlined" color="warning" sx={sx} />;
};
